import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table,Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faArrowRight, faPlay } from '@fortawesome/free-solid-svg-icons';
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import Overlay from '../../../Common/overlay';
import EmptyDataIcon from '../../../../images/empty_data_icon.png'
import DownloadIcon from '../../../../images/download_icon.svg'
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';
import exportToCSV from '../../../Common/exportcsv';
import PlusIcon from '../../../../images/plus.svg';
import callapiobj from '../../../Common/api';
import ShapeLeft from '../../../../images/ShapeLeft.svg';
import ShapeRight from '../../../../images/ShapeRight.svg';
import FirstPage from '../../../../images/firstPageIcon.svg';
import greenTick from '../../../../images/green-tick.svg';

import LastPage from '../../../../images/lastPageIcon.svg';
import DatePicker from "react-datepicker";
import {base_url} from '../../../Common/api';







var url =  window.location.hostname;
var port = window.location.port;
// const Heading = [['ID', 'Warehouse', 'Brand', 'Area Code','Nearby Area Code' ]]
const Heading = [['ID', 'Area Code','Nearby Area Code' ]]




class POCreationDetails extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  


  constructor() {
   super();
   this.fetchPOData = this.fetchPOData.bind(this);
   this.toggle = this.toggle.bind(this);
   this.toggleFailed = this.toggleFailed.bind(this);


    this.state = {
    loading_overlay: false, 
      file: {},
      data: [],
      cols: [],
      brandList: [],
      selectedBrands: [],
      supplierCodeData: [],
      statusLabel: "",
      hoveredId: null,
      trackingOverlayPos: { top: 0, left: 0 },
      trackingData: [],
      trackingDataMap: {},
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem:false,
      showInvalidProductItem:false,
      showResponseData: false,
      showBaseResponseData: false,
      trackingDataLoading: false,

      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      itemCreationStatusList: [],
      startCount: 0,
      endCount: 0,
      entriesPerPage: 10,
      itemTypeList: [],
      itemCategoryList: [],
      statusList: [],
      tableRowsTester: [],
      enableCreateCycle: false,
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      loading: false,
      isLoading:true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,
      genloading: false,
      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      currentPage: 1,
      totalPages: 1,
      totalItems: 0,
      startIndex: 0,
      endIndex: 0,
      loadingText: 'Loading...',
  
    };
  }


  componentDidMount(){
    this.fetchPOData();
    this.getBrand();
    this.getStatusData();
    this.getSupplierCode();
  }


  componentWillMount(){

      if (window.location.port == 8091 || window.location.port === ":8090") {
          port = ":8090"
        }else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    }else{
          port = ":8088"
        }

      if (url === "localhost") {
        url= "15.206.34.41"+":8090";

      }else{
        url= window.location.hostname+port;
      }

      var cookieUsername = Util.getCookie('token');
      var location = Util.getCookie('selectedLocation');
      var username = Util.accessCookie("token");
      this.setState({
        userName: cookieUsername,
        selectedLocation: location
      })

      localStorage.setItem('userName' , username);
    }


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

 

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));  
  }

  

  viewSingleItem = (id, po_number,rejected_reason)=>{
    
    window.location.href = '/receiving/view_single_po_details?tab=po_list&id='+id+'&po_num='+po_number+'&rejected_reason='+rejected_reason;
  }

  createTaxGroup = ()=>{
    window.location.href = '/receiving/create_new_po'
  }
 

  fetchPOData(page = 1, searchTerm = ''){


      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: false,
        loading_overlay:true
      })


     const payload = {
        ...(this.state.selectedBrandNames ? { brand: this.state.selectedBrandNames } : {}),
        ...(this.state.status ? { status: this.state.status } : {}),
        ...(this.state.po_number ? { po_number: this.state.po_number } : {}),
        ...(this.state.supplier_code ? { supplier_code: this.state.supplier_code } : {}),
        ...(page == 1 ? {} : {page: page}),
        ...(this.state.entriesPerPage ? { page_size: this.state.entriesPerPage } : {}),
        ...(searchTerm ? { search: searchTerm } : {}),
      };
      
      /*const url = page === 1 ? '/tax/v1/item-list/product/' : `/tax/v1/item-list/product/?page=${page}`;
      API.get(url)*/
      callapiobj.get('/receiving/po-creation', { param: payload })

      .then(response => response.data)

      .then(data => {

        console.log("PO Data",data.data);
         
         

         // if (err) throw err;
        if(data.data.length > 0){
          const { data: posts, pagination } = data;
          const perPage = Math.ceil(pagination.count / pagination.total_pages);

          // Calculate startIndex and endIndex based on pagination data
          const startIndex = (pagination.current_page - 1) * perPage + 1;
          const endIndex = Math.min(pagination.current_page * perPage, pagination.count);


         this.setState({posts: data.data, currentPage: pagination.current_page,
          totalPages: pagination.total_pages, totalItems: pagination.count,
          startIndex: startIndex,perPage: perPage,
          endIndex: endIndex,startCount: pagination.showing.start, endCount: pagination.showing.end })

        }else{
          this.setState({posts: data.data})
        }
          

      })

      .then(async() => {

         this.setState({ tableRows:this.assemblePosts(), loading_overlay:false })

         console.log(this.state.tableRows);

      });
  }

  handlePageChange(pageNumber) {
    this.fetchPOData(pageNumber);
  }

  handleSearchInput = (e) => {
    const searchValue = e.target.value;
    this.setState({ searchTerm: searchValue }); // optional, for reuse in pagination
    if(searchValue == ""){
      this.fetchPOData(1, searchValue);
    }
     
  };

  handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.fetchPOData(1, this.state.searchTerm);
    }
  };

  /*fetchTrackingData = (id) => {
    
    API.get(`/receiving/po-creation/track/${id}`)
    .then((response) => response.data)

    .then((data) => {
      console.log("tracking DATA",data);
      return false;
      const transformedBrands = data.data.map((brand) => ({
          label: brand.name,
          value: brand.name,
      }));
      this.setState({ brandList: transformedBrands });
    })

    .then(async () => {
      
    });
  }*/

  fetchTrackingData = (id) => {
  this.setState({ trackingDataLoading: true });
  
  API.get(`/receiving/po-creation/track/${id}`)
    .then(response => {
      var steps = (response && response.data && response.data.data) || [];
      this.setState(prevState => ({
        trackingDataMap: { ...prevState.trackingDataMap, [id]: steps },
        trackingDataLoading: false,
      }));
    })
    .catch(error => {
      console.error("Error fetching tracking data:", error);
      this.setState({ trackingDataLoading: false });
    });
};




  getBrand = () => {
    
    API.get('/tax/v1/filter/brands')
    .then((response) => response.data)

    .then((data) => {
      console.log("brand",data);
      const transformedBrands = data.data.map((brand) => ({
          label: brand.name,
          value: brand.name,
      }));
      this.setState({ brandList: transformedBrands });
    })

    .then(async () => {
      
    });
  }

  getSupplierCode = ()=>{
    API.get('/receiving/po-creation/supplier?warehouse='+Util.getCookie("selectedLocation"))
    .then((response) => response.data)

    .then((data) => {
      console.log("Supplier",data);
      this.setState({ supplierCodeData: data.data });
    })

    .then(async () => {
      
    });

  }

  getStatusData = () => {
    
    API.get('/receiving/po-creation/status')
    .then((response) => response.data)

    .then((data) => {
      console.log("STATUS",data.data.status)
      this.setState({ 
        statusList: data.data.status


       });
    })

  }

  handleChangeEvent = (evt) => {
    const { name, value, selectedOptions } = evt.target;

    if (name === "status") {
      const label = selectedOptions && selectedOptions.length > 0 ? selectedOptions[0].text : '';
      this.setState({
        [name]: value,
        statusLabel: label,
      });
      console.log("status", value, label);
    } else {
      this.setState({ [name]: value });
      console.log(name, value);
    }
  };

  downloadExcel = async(searchFlag, searchTerm = '') => {
    this.setState({ isDownloading: true });
    const token = Util.accessCookie("token");
    let url = `${base_url}/receiving/po-creation/download`;
    
    // Append brand parameter only if it exists
    if (this.state.selectedBrandNames) {
        url += `?brand=${this.state.selectedBrandNames}`;
    }

    if (this.state.po_number) {
        url += `?po_number=${this.state.po_number}`;
    }

    if (this.state.status) {
        url += `?status=${this.state.status}`;
    }
    if (this.state.supplier_code) {
        url += `?supplier_code=${this.state.supplier_code}`;
    }

    if (this.state.searchTerm) {
        url += `?search=${this.state.searchTerm}`;
    }

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute("download", "po_list.csv"); // Set filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.setState({ isDownloading: false });
    } catch (error) {
      console.error("Error downloading file:", error);
      this.setState({ isDownloading: false });
    }
  };
 
 
  componentDidUpdate(prevProps, prevState) {
    if (prevState.hoveredId !== this.state.hoveredId) {
      console.log("hoveredId updated to:", this.state.hoveredId);
    }
  }

  assemblePosts = () => {
    const {
      posts,
      hoveredId,
      trackingDataMap,
      trackingDataLoading,
      enableCreateCycle,
      genloading,
      trackingOverlayPos
    } = this.state;

    const postRows = posts.map((post) => {
      const status = post.status.value;

      let statusStyle = {
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        color: '#000',
        backgroundColor: '#f0f0f0',
      };

      if (status === "Approved") {
        statusStyle = {
          ...statusStyle,
          backgroundColor: '#E6F4EA',
          color: '#34A853',
        };
      } else if (status === "Pending for Approval") {
        statusStyle = {
          ...statusStyle,
          backgroundColor: '#FEF1CC',
          color: '#FB8C00',
        };
      } else if (status === "Rejected") {
        statusStyle = {
          ...statusStyle,
          backgroundColor: '#FFF0EF',
          color: '#FF3C00',
        };
      }

      const trackingData = trackingDataMap[post.id] || [];

      return {
        invoice_number: (
          <div
            style={{ position: 'relative', display: 'inline-block' }}
            onMouseEnter={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const overlayTop = rect.bottom + window.scrollY;
              const overlayLeft = rect.left + window.scrollX;

              this.setState(
                {
                  hoveredId: post.id,
                  trackingDataLoading: true,
                  trackingOverlayPos: { top: overlayTop, left: overlayLeft }
                },
                () => this.fetchTrackingData(post.id)
              );
            }}
            onMouseLeave={() => {
              this.setState({ hoveredId: null, trackingDataLoading: false });
            }}
          >
            <span style={{ color: '#33A0FF', cursor: 'pointer' }}>
              {post.invoice_number}
            </span>

            {hoveredId === post.id &&
              ReactDOM.createPortal(
                <div
                  style={{
                    position: 'absolute',
                    top: trackingOverlayPos.top,
                    left: trackingOverlayPos.left,
                    zIndex: 9999,
                    backgroundColor: '#fff',
                    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
                    padding: '16px',
                    borderRadius: '8px',
                    minWidth: '360px',
                    maxWidth: '90vw',
                  }}
                >
                  <strong>Track Invoice - {post.invoice_number}</strong>

                  {trackingDataLoading ? (
                    <div style={{ marginTop: 16 }}>Loading...</div>
                  ) : (
                    <ul
                      style={{
                        marginTop: '16px',
                        paddingLeft: '0',
                        listStyle: 'none',
                      }}
                    >
                      {trackingData.map((step, idx) => (
                        <li
                          key={idx}
                          style={{
                            marginBottom: idx === trackingData.length - 1 ? '0' : '16px',
                            position: 'relative',
                            paddingLeft: '28px',
                          }}
                        >
                          <span
                            style={{
                              position: 'absolute',
                              left: '0',
                              top: '4px',
                              width: '20px',
                              height: '20px',
                              borderRadius: '50%',
                              backgroundColor: '#34A853',
                              color: '#fff',
                              textAlign: 'center',
                              lineHeight: '20px',
                              fontWeight: 'bold',
                              fontSize: '14px',
                              zIndex: 2,
                            }}
                          >
                            <img src={greenTick} />
                          </span>

                          {idx !== trackingData.length - 1 && (
                            <span
                              style={{
                                position: 'absolute',
                                left: '8px',
                                top: '28px',
                                width: '1px',
                                height: 'calc(100% - 16px)',
                                backgroundColor: '#1AA71B',
                                zIndex: 1,
                              }}
                            />
                          )}

                          <div>
                            <div style={{ fontWeight: 'bold' }}>{step.action.value}</div>
                            <div style={{ fontSize: '12px', color: '#555' }}>
                              {new Date(step.added_on).toLocaleDateString()}{' '}
                              {new Date(step.added_on).toLocaleTimeString([], {
                                hour: '2-digit',
                                minute: '2-digit',
                              })}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>,
                document.body
              )}
          </div>
        ),

        po_number: post.po_number,
        brand: post.brand,
        po_date: post.po_date,
        supplier_code: post.supplier_code ? post.supplier_code.name : "",
        status: <span style={statusStyle}>{post.status.value}</span>,
        reason: post.reason ? post.reason.description : '',
        action: (
          <Button
            className="white_bckgrd_button"
            style={{
              fontWeight: "normal",
              textTransform: "capitalize",
              borderRadius: 5,
              backgroundColor: "#fff",
              color: enableCreateCycle ? '#fff' : "black",
              padding: "5px 25px",
              fontSize: "14px",
              float: 'left',
            }}
            id="white_bckgrd_button"
            disabled={enableCreateCycle}
            onClick={() => this.viewSingleItem(post.id, post.po_number,post.reason.description)}
          >
            {genloading && (
              <i className="fa fa-refresh fa-spin" style={{ marginRight: "5px" }} />
            )}
            View
          </Button>
        ),
      };
    });

    this.setState({ loading_overlay: false });
    return postRows;
  };






 
 
  render() {
    const { handleSubmit, reset, t } = this.props;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;
    const { tableRows, currentPage, totalPages, totalItems, startIndex, endIndex, loading_overlay } = this.state;

       const data = {

      columns: [


      {
        label: "Invoice Number",
        field: "invoice_number",
        sort: "asc",
        width: 140,
        columnClassName: "col-invoice-number",
        cellClassName: "col-invoice-number",
      },
      {
        label: "PO Number",
        field: "po_number",
        sort: "asc",
        width: 150,
        columnClassName: "col-invoice-number",
        cellClassName: "col-invoice-number",
      },
      {
        label: "Brand",
        field: "brand",
        sort: "asc",
        width: 100,
        columnClassName: "col-invoice-number",
        cellClassName: "col-invoice-number",
      },
      {
        label: "PO Date",
        field: "po_date",
        sort: "asc",
        width: 120,
        columnClassName: "col-invoice-number",
        cellClassName: "col-invoice-number",
      },
      {
        label: "Supplier Code",
        field: "supplier_code",
        sort: "asc",
        width: 150,
        columnClassName: "col-invoice-number",
        cellClassName: "col-invoice-number",
      },
      {
        label: "Status",
        field: "status",
        sort: "asc",
        width: 170,
        columnClassName: "col-invoice-number",
        cellClassName: "col-invoice-number",
      },
      {
        label: "Reason",
        field: "reason",
        sort: "asc",
        width: 180,
        columnClassName: "col-invoice-number",
        cellClassName: "col-invoice-number",
      },
      {
        label: "Action",
        field: "action",
        sort: false,
        width: 120,
        columnClassName: "col-invoice-number",
        cellClassName: "col-invoice-number",
      },

        

      ],

      rows:this.assemblePosts(),

    }

    return (
      <Col xl={12}>
         {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>
           
            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>
          <Overlay>
            <form className="form" onSubmit={handleSubmit}>
             <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
                <span className="filter_title">Filters</span>
            </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">PO Number</span>
                <div style={{ position: 'relative' }}>
                  <input
                        type="text"
                        style={{ height: 38 }}
                        className="form-control"
                        placeholder="PO Number"
                        name="po_number"
                        onChange={this.handleChangeEvent}
                      />
                </div>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                  <span className="date_title">Select Date</span>
                  <div style={{ position: 'relative' }}>
                      <DatePicker
                          selected={this.state.from_date}
                          onChange={this.FromDateChange}
                          className="ledger_fromdate"
                          placeholderText="From Date"
                          format='yyyy-MM-dd'
                      />
                      <i className="fa fa-calendar" style={{ position: 'absolute', right: '10px', top: '10px', pointerEvents: 'none' }}></i>
                  </div>
                  {this.state.showFromErr && (
                      <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
                  )}
                   {this.state.dateOrderError && (
                    <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
                  )}
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Supplier Code</span>
                <div style={{ position: 'relative' }}>
                  <select
                    className="form-control"
                    value={this.state.supplier_code}
                    style={{ fontSize: 13 }}
                    name="supplier_code"
                    onChange={this.handleChangeEvent}
                  >
                    <option value="">Select</option>
                    {this.state.supplierCodeData.length > 0 &&
                      this.state.supplierCodeData.map((items) => {
                        return (
                          <option value={items.name}>
                            {" "}
                            {items.name}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Status</span>
                <div style={{ position: 'relative' }}>
                  <select
                    className="form-control"
                    value={this.state.status}
                    style={{ fontSize: 13 }}
                    name="status"
                    onChange={this.handleChangeEvent}
                  >
                    <option value="">Select</option>
                    {this.state.statusList.length > 0 &&
                      this.state.statusList.map((status) => {
                        return (
                          <option value={status.id}>
                            {" "}
                            {status.label}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>

              <div style={{ width: '100%', marginBottom: '0px', float: 'left', marginRight: 5, marginTop: '12%' }}>
                <span className="date_title">Brand</span>
                <div style={{ position: 'relative' }}>
                  <div style={{ maxWidth: '100%', minHeight: 45 }}>
                    <Select
                      isMulti
                      options={this.state.brandList}
                      value={this.state.selectedBrands}
                      onChange={(selectedOptions) => {
                        const brandNames = selectedOptions.map(option => option.value).join(',');
                        this.setState({
                          selectedBrands: selectedOptions,
                          selectedBrandNames: brandNames,
                        });
                      }}
                      closeMenuOnSelect={false}
                      menuPlacement="auto"
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          maxHeight: 80,
                          overflowY: 'auto',
                          flexWrap: 'wrap',
                        }),
                        control: (base, state) => ({
                          ...base,
                          minHeight: 38,
                          overflow: 'hidden',
                          flexWrap: 'wrap',
                          borderColor: state.isFocused ? '#2684FF' : base.borderColor,
                          boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : base.boxShadow,
                        }),
                        multiValue: (base) => ({
                          ...base,
                          maxWidth: '100%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }),
                      }}
                    />
                  </div>

                </div>
              </div>

              <div className="filter_button_container" style={{ width: '100%', marginBottom: '0px', float: 'left' }}>
                <ButtonToolbar className="form__button-toolbar">
                  <Button
                    className="btn-sm button_enable1 "
                    style={{

                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 6,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                      marginRight: '10px', // Add some spacing between buttons
                    }}
                    id="button_view"
                    onClick={() => this.fetchPOData()}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    View 
                  </Button>

                  <Button
                    type="button"
                    className="btn btn-primary-outline"
                    style={{
                        cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                        backgroundColor: '#FFFFFF',
                        padding: "5px 25px",
                        color: '#333333', // Set text color
                        display: 'flex',   // Use flexbox to align image and text
                        alignItems: 'center' // Center items vertically
                    }}
                    id="button_download"
                    onClick={() => this.downloadExcel()}
                    >
                    
                    <img
                        src={DownloadIcon}
                        alt="Download"
                        style={{ width: '25px' }} // Adjust size as needed
                    />
                    Download
                  </Button>
                </ButtonToolbar>                     
              </div>
            </form>
          </Overlay>

          <div>
            {this.state.po_number && (
              <div className="filter-display" >
                {this.state.po_number}
                
              </div>
            )}

             
           {this.state.selectedBrands.length > 0 && (
              <div>

                {this.state.selectedBrands.map((brand, index) => (
                  <div className="filter-display" key={brand.value}>
                    {brand.label}
                    
                  </div>
                ))}
              </div>
            )}
           {this.state.supplier_code && (
              <div style={{width: 140}} className="filter-display" >
                {this.state.supplier_code}
                
              </div>
            )}
              
            {this.state.status && (
              <div className="filter-display" >
                {this.state.statusLabel}
                
              </div>
            )}
          </div>

          <div
            className="form__form-group"
            style={{ display: "inline-flex", marginTop: 10 }}
          >
            <div
              className="form__form-group-field"
              style={{ display: "block" }}
            >
                 

              <Button
                className="btn-sm button_enable "
                style={{
                  fontWeight: "normal",
                  textTransform: "capitalize",
                  borderRadius: 5,
                  backgroundColor: "#70bbfd",
                  color: "#fff",
                  padding: "5px 25px",
                  fontSize: "14px",
                  backgroundColor: this.state.enableCreateCycle === true ? '#c1c1c1': "#FBBB00",
                  color: this.state.enableCreateCycle === true ? '#fff': "black",
                }}
                id="button_view"
                disabled= {this.state.enableCreateCycle}
                onClick={this.createTaxGroup}
              >
                {this.state.genloading && (
                  <i
                    className="fa fa-refresh fa-spin"
                    style={{ marginRight: "5px" }}
                  />
                )}
                 <img
                    src={PlusIcon}
                    alt="Plus"
                    style={{ width: '17px', marginRight: 6 }} // Adjust size as needed
                />
                 Create New PO
              </Button>     
            </div>
          </div>
          {
            this.state.showFetchBinData  && (

              <div id="masterTableContainer" className="taxmaster_table">
                <div className="showEntriesContainer" style={{ display: 'flex', alignItems: 'center', width: '75%', float: 'left',  marginTop: 6  }}>
                  <span style={{ marginRight: '0.5rem' }}>Show</span>
                  <select
                    id="showEntriesSelect"
                    value={this.state.entriesPerPage}
                    style={{height: 28}}
                    onChange={(e) => {
                      const newLimit = parseInt(e.target.value, 10);
                      this.setState({ entriesPerPage: newLimit }, () => {
                        this.fetchPOData(currentPage, ""); // Reset to page 1 when changing page size
                      });
                    }}
                    style={{ marginRight: '0.5rem' }}
                  >
                    {[10, 25, 50, 100].map((num) => (
                      <option key={num} value={num}>{num}</option>
                    ))}
                  </select>
                  <span>entries</span>
                </div>

                <div className="showEntriesContainer" style={{ display: 'flex', alignItems: 'center', width: '25%', float: 'left' }}>
                  <input
                    type="text"
                    className="form-control mb-3"
                    placeholder="Search"
                    value={this.state.searchTerm}
                    onChange={this.handleSearchInput}
                    onKeyDown={this.handleKeyDown}
                    id="searchInput"
                  />
                  {this.state.isDownloading ? (
                    <a
                      className="pull-right"
                      style={{
                        fontSize: "17px",
                        paddingRight: "0px",
                        cursor: "pointer",
                        color: "#919193",
         
                        marginLeft: 6
                      }}
                    >
                         
                    <FontAwesomeIcon icon={faSpinner} spin />
                    </a>
                    ) : (
                    <a
                      target="_blank"
                       /*href={`${base_url}/tax/v1/group/product/download/?tax_group=${paramValue}`}*/
                      onClick={() => this.downloadExcel()}
                       /*href={`${base_url}/tax/v1/group/product/download/?tax_group=${encodeURIComponent(paramValue)}&token=c2640975d90b176066d3caa8287ead6a367f7031`}*/
                      className="pull-right"
                      //onClick={() => exportToCSV(this.state.posts, "AreaMaster", Heading)}
                      style={{
                        fontSize: "17px",
                        paddingRight: "0px",
                        cursor: "pointer",
                        color: "#919193",
                        marginLeft: 6
                      }}
                      >
                      <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                    </a>

                  )}
                </div>

               {/* <MDBDataTable
                  striped
                  bordered
                  hover
                  data={{
                    columns,
                    rows: this.assemblePosts(),
                  }}
                  
                  sortable={true}
                  paging={false}
                        searching= {false}
                        onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'category_master_view', 'datatable_pagination_change' )}
                />*/}
        

                <MDBDataTable
                striped
                scrollX
                bordered
                sortable={true}
                hover
                data={data}
                paging={false}
                searching= {false}
                onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'category_master_view', 'datatable_pagination_change' )}
                />

              <div className="pagination-container1" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem' }}>
                <div className="pagination-left">
                  <span>Showing {this.state.startCount} to {this.state.endCount} out of {totalItems}</span>
                </div>

                <div className="pagination-right" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  {/* First */}
                  <img
                    src={FirstPage}
                    alt="firstPage"
                    style={{ cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
                    onClick={() => currentPage !== 1 && this.handlePageChange(1)}
                  ></img>

                  {/* Previous */}
                  <img
                    src={ShapeLeft}
                    alt="Previous"
                    style={{ width: '12px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer', opacity: currentPage === 1 ? 0.5 : 1 }}
                    onClick={() => currentPage !== 1 && this.handlePageChange(currentPage - 1)}
                  />

                  {/* Page Numbers */}
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => {
                    if (
                      pageNum === 1 ||
                      pageNum === totalPages ||
                      (pageNum >= currentPage - 2 && pageNum <= currentPage + 2)
                    ) {
                      return (
                        <span
                          key={pageNum}
                          onClick={() => this.handlePageChange(pageNum)}
                          style={{
                            fontWeight: currentPage === pageNum ? 'bold' : 'normal',
                            color: currentPage === pageNum ? '#FBBB00' : '#000',
                            cursor: 'pointer'
                          }}
                        >
                          {pageNum}
                        </span>
                      );
                    } else if (
                      pageNum === currentPage - 3 ||
                      pageNum === currentPage + 3
                    ) {
                      return <span key={pageNum}>...</span>;
                    } else {
                      return null;
                    }
                  })}

                  {/* Next */}
                  <img
                    src={ShapeRight}
                    alt="Next"
                    style={{ width: '12px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                    onClick={() => currentPage !== totalPages && this.handlePageChange(currentPage + 1)}
                  />

                  {/* Last */}
                  <img
                    src={LastPage}
                    alt="lastPage"
                    style={{ cursor: currentPage === totalPages ? 'not-allowed' : 'pointer', opacity: currentPage === totalPages ? 0.5 : 1 }}
                    onClick={() => currentPage !== totalPages && this.handlePageChange(totalPages)}
                  ></img>
                </div>
              </div>
            </div>

          )}
        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggle} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#24d6a3', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{maxWidth: 578}}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.toggleFailed} />
            
           
          </div>
          <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{backgroundColor: '#ddd', color: '#fff'}} className="modal_ok"  onClick={this.togglePressCancel}>Cancel</Button>
            
          </ButtonToolbar>
        </Modal>

      


      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(POCreationDetails));